// Step event types for the events endpoint; values are what the backend stores,
// so submit stays 'complete' for compatibility
export const STEP_EVENT_SUBMIT = 'complete';
export const STEP_EVENT_LOAD = 'load';
export const STEP_EVENT_SKIP = 'skip';
export const STEP_EVENT_BACK = 'back';
